module.exports = __webpack_public_path__ + "img/better-experience-icon.2305fb98.png";